import React, { useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.jsx";
import {
  getWhatsappEncryptedTextUrl,
  getWhatsappUserToken,
} from "../../views/common/whatsapp";

const style = {
  grid: {
    padding: "0 5px !important",
  },
};

function WhatsApp({ classes, PhoneCode, Phone, user, enableWhatsappButton, ...rest }) {
  const [countdown, setCountdown] = useState(0); // State to manage the countdown
  const formattedPhoneCode = PhoneCode === 91 ? "91" : "";
  const formattedPhone = Phone ? Phone.toString().replace("+", "") : "";
  let whatsappLink = `whatsapp://send?phone=${formattedPhoneCode}${formattedPhone}`;
  

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    if (isMobile) {
      whatsappLink = `whatsapp://send?phone=${formattedPhoneCode}${formattedPhone}`;
    } else {
      whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneCode}${formattedPhone}`;
    }

    // Use window.location.href to navigate to the WhatsApp link
    window.open(whatsappLink, "_blank", "noopener,noreferrer"); // Open WhatsApp in a new tab
    //window.location.href = whatsappLink; // Redirect to WhatsApp link
    // setTimeout(() => {
    //     window.history.forward(); // Navigate to the next page
    // }, 1000);

    return false; // Prevent default action
  };

  const inbox = async () => {
    const userwhatsappData = await getWhatsappUserToken();
    const testObj = {
      admin: user.admin,
      userId: userwhatsappData.userId,
      token: userwhatsappData.token,
      phoneNumberId: user.whatsappPhoneId,
      chatWith: `${formattedPhoneCode}${formattedPhone}`,
    };

    console.log(testObj);
    const encryptedTest = await getWhatsappEncryptedTextUrl(testObj);

    // Open in new tab
    window.open(
      `https://metawhatsapp.betyphon.in/inbox/?data=${encryptedTest}`,
      "_blank"
    );
  };

  /* WhatsApp button */
  return (
    <>
      {enableWhatsappButton  != false && (
        <a
        
          onClick={handleWhatsAppClick}
          
          style={{ cursor: "pointer", position: "relative","background": "white",
    "fontSize": "30px",
    "top": "7px",color:"green" }}
        >
          <i className="fa fa-whatsapp" />
        </a>
      )}

      {user && user.whatsappPhoneId && (
        <a
          style={{ background: "white" }}
          onClick={() => inbox()}
          target="_blank"
          rel="noopener noreferrer" // To ensure security for external links
        >
          <img
            style={{
              position: "relative",
              width: "37px",
              top: "13px",
              right: "6px",
            }}
            className="beta"
            src="/metawhatsapp.png"
          />
        </a>
      )}
    </>
  );
}

export default withStyles(style)(WhatsApp);
